import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    siteData: {},
    fullLoading: true,
    navigationDrawer: true,
    siteSettings: {},
    offlineMode: false,
    miniNavState: true,
    infoBlurb: {
      value: null,
      routeNames: [],
    },
  },
  mutations: {
    setFullLoader(state, loading) {
      if (!loading) {
        setTimeout(() => {
          state.fullLoading = loading;
        }, 500);
      } else {
        state.fullLoading = loading;
      }

    },
    setNavigationDrawer(state, drawer) {
      state.navigationDrawer = drawer;
    },
    setOfflineMode(state, mode) {
      state.offlineMode = mode;
    },
    setMiniNavState(state, payload) {
      state.miniNavState = payload;
    },
    setInfoBlurb(state, payload) {
      state.infoBlurb = payload;
    },
  },
  actions: {
    checkOnlineStatus({ commit }) {
      commit("setOfflineMode", !navigator.onLine);
    },
    setFullLoaderState({ commit }, loading) {
      commit("setFullLoader", loading);
    },
    async setNavigationDrawerState({ commit }, payload) {
      commit("setNavigationDrawer", payload);
    },

    randomString({ commit }, payload) {
      var mask = "";
      if (payload.chars.indexOf("a") > -1) mask += "abcdefghijklmnopqrstuvwxyz";
      if (payload.chars.indexOf("A") > -1) mask += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      if (payload.chars.indexOf("#") > -1) mask += "0123456789";
      if (payload.chars.indexOf("!") > -1)
        mask += "~`!@#$%^&*()_+-={}[]:\";'<>?,./|\\";
      var result = "";
      for (var i = payload.len; i > 0; --i)
        result += mask[Math.floor(Math.random() * mask.length)];
      return result;
    },

    togglMiniNav({ commit, state }, payload) {
      commit("setMiniNavState", !state.miniNavState);
    },
    changeMiniNav({ commit }, payload) {
      commit("setMiniNavState", payload);
    },

    async contactSupport({ commit }, payload) {
      payload.toEmail = "support@upstreamnzsolutions.com";
      payload.subject = "Support request from PWA";

      await api.post("simpleSoftwareContactForm", payload);
    },

    async setInfoBlurb({ commit }, payload) {
      commit("setInfoBlurb", payload);
    },
  },
  getters: {
    siteData(state) {
      return state.siteData;
    },
    fullLoading(state) {
      return state.fullLoading;
    },
    navigationDrawer(state) {
      return state.navigationDrawer;
    },
    offlineMode(state) {
      return state.offlineMode;
    },
    miniNavState(state) {
      return state.miniNavState;
    },
    infoBlurb(state) {
      return state.infoBlurb;
    },
  },
};
